import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../productPageStyle.js";
import SectionHead from "./SectionHead.js";
import { certWhatRowsFor } from "../certRows.js";

const useStyles = makeStyles(styles);

/**
 * B-01 §28.3 item 1: what the mark actually says about this product — the
 * §29 summary, then B-01 §6 row by row in the same ledger as LimitsSection —
 * plus the scope. The claim and its limits are two separate numbered sections now
 * — see LimitsSection — because compressing them into one card is exactly the
 * omission this page exists to fix. The rows follow the product's registry
 * category, so a detergent is not described by cosmetics' criteria.
 */
export default function CertificationSection({ t, num, category }) {
  const classes = useStyles();

  return (
    <section id="section-certification" className={classes.section}>
      <SectionHead num={num} title={t.certWhatTitle} />
      <div className={classes.sectionBody}>
        <p className={classes.paragraph}>{t.certWhatBody}</p>
        <div className={classes.ledger}>
          {certWhatRowsFor(t, category).map((row, i) => (
            <div className={classes.ledgerRow} key={row.claim}>
              <span className={`${classes.ledgerNum} ${classes.ledgerNumGreen}`}>
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className={classes.ledgerCell}>
                <p className={classes.ledgerClaim}>{row.claim}</p>
                <p className={classes.ledgerWhy}>{row.why}</p>
              </div>
            </div>
          ))}
        </div>
        <div className={classes.scope}>
          <span className={classes.scopeLabel}>{t.scopeLabel}</span>
          <p className={classes.scopeValue}>{t.scopeValue}</p>
        </div>
      </div>
    </section>
  );
}
